export const itemLabel = {
    fontSize: 's',
    lineHeight: 'default',
};
export const itemDescription = {
    fontSize: 'xs',
    lineHeight: 'default',
    color: 'secondary',
};
//# sourceMappingURL=autocomplete.js.map